import BoxKit from "@/shared/components/kit/box";
import CustomButton from "@/shared/components/kit/button";
import StackKit from "@/shared/components/kit/stack";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import React, { useState } from "react";
/**
 * UploadDocuments
 *
 * یک کامپوننت برای آپلود تصاویر با قابلیت نمایش پیش‌نمایش تصویر انتخاب‌شده.
 * این کامپوننت:
 * - از BoxKit و StackKit برای ساختار و چیدمان استفاده می‌کند
 * - از CustomButton و TypoGraphyKit برای رابط کاربری و متن‌ها بهره می‌برد
 * - قابلیت انتخاب تصویر از سیستم کاربر و نمایش پیش‌نمایش آن را دارد
 * - اگر تصویری انتخاب نشده باشد، راهنمایی برای کشیدن و رها کردن فایل و دکمه انتخاب فایل نمایش می‌دهد
 *
 * @param label — متن دکمه انتخاب فایل، به صورت اختیاری (پیش‌فرض: "بارگذاری تصویر")
 * @param defaultImage — تصویر پیش‌فرضی که باید هنگام بارگذاری نمایش داده شود
 * @param onUpload — تابع اختیاری که فایل انتخاب شده را برمی‌گرداند
 *
 * @returns JSX.Element
 */
export default function UploadDocuments({label = "بارگذاری تصویر",defaultImage = "",onUpload,}: {label: string;defaultImage: string;onUpload?: any;}) {
  const [image, setImage] = useState<string | null>(null);
  const inputRef = React.useRef<HTMLInputElement | null>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImage(reader.result as string);
        onUpload?.(file);
      };
      reader.readAsDataURL(file);
    } else {
      onUpload?.(null);
    }
  };

  const handleClick = () => {
    inputRef.current?.click();
  };

  return (
    <BoxKit
      sx={{
        width:{xs:250 , sm:350 , md:450, lg:520},
        height: 300,
        borderRadius: "8px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        overflow: "hidden",
        cursor: "pointer",
        bgcolor: "#434343",
      }}
      onClick={handleClick}
    >
      <BoxKit
        component="div"
        sx={{
          position: "absolute",
          width: "100%",
          height: "100%",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundImage: image ? `url(${image})` : "none",
          filter: image ? "none" : "blur(4px)",
          transition: "0.3s",
        }}
      />

      {!image && (
        <BoxKit
          sx={{
            bgcolor: "#434343",
            width: "100%",
            height: "100%",
            position: "absolute",
            top: 0,
            left: 0,
            zIndex: 100,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: 3,
          }}
        >
          <StackKit sx={{ height: "300px" }} justifyContent={"center"} alignItems={"center"}>
            <TypoGraphyKit variant="subtitle1" sx={{ color: "#767676" }}>
              آپلود فایل عکس
            </TypoGraphyKit>
            <TypoGraphyKit variant="body1" sx={{ color: "#767676" }}>
              فایل عکس مورد نظر برای سازمان خود را به فرمت jpeg یا png با حداکثر
              حجم 1 مگابایت بارگزاری نمایید
            </TypoGraphyKit>
          </StackKit>
          <StackKit onClick={handleClick} direction={"column"} sx={{ width: "100%", marginBottom: "20px", padding: "0 10px" }} justifyContent={"space-between"} alignItems={"center"}>
            <TypoGraphyKit variant="body1" sx={{ marginRight: "20px" }}>
              فایل مورد نظر را بکشید و در این بخش رها کنید
            </TypoGraphyKit>
            <CustomButton sx={{ bgcolor: "#5A5A5A" }}>
              <TypoGraphyKit variant="body1">انتخاب فایل</TypoGraphyKit>
            </CustomButton>
          </StackKit>
        </BoxKit>
      )}

      {!image && (
        <BoxKit sx={{width: "100%",height: "300px",borderRadius: "8px",background: "transparent",border: "6px dashed #767676",position: "absolute",zIndex: 200,}}/>
      )}

      <input type="file" ref={inputRef} accept="image/*" style={{ display: "none" }} onChange={handleChange}/>
    </BoxKit>
  );
}
